// extracted by mini-css-extract-plugin
export default {"content":"ToDoItem_content__boqEa","date":"ToDoItem_date__2aysm","todo":"ToDoItem_todo__oRaXy","checkbox":"ToDoItem_checkbox__hCUdD"};